import type { State } from './state';
import { getters as GETTERS } from './types';
import { getFieldsFromObject } from '@/app/utils/helpers';

const sortedPages = (state: State, type: string) => {
  const typeSource = (state as any)[type];
  const output = (typeSource?.list || []).map((x: any) => x);

  output.sort((a: any, b: any) => {
    if (
      ['Theme Index Template', 'Your first Homepage', 'Theme Product Template', 'Theme Collection Template'].includes(
        a.title,
      )
    ) {
      return -1;
    }

    if (
      ['Theme Index Template', 'Your first Homepage', 'Theme Product Template', 'Theme Collection Template'].includes(
        b.title,
      )
    ) {
      return 1;
    }

    if (['template-index', 'template-product', 'template-collection'].includes(a.type) && a.published) return -1;

    if (['template-index', 'template-product', 'template-collection'].includes(b.type) && b.published) return 1;

    return 1;
  });
  return output;
};

const getters = {
  [GETTERS.SORTED_ARTICLE](state: State) {
    return sortedPages(state, 'article');
  },
  [GETTERS.SORTED_COLLECTION](state: State) {
    return sortedPages(state, 'collection');
  },
  [GETTERS.SORTED_INDEX](state: State) {
    return sortedPages(state, 'index');
  },
  [GETTERS.SORTED_PAGES](state: State) {
    return sortedPages(state, 'page');
  },
  [GETTERS.SORTED_PRODUCT](state: State) {
    return sortedPages(state, 'product');
  },
  // page setting
  generalDefaultForm(state: State) {
    return state.defaultPageSettingForm.general;
  },
  layoutDefaultForm(state: State) {
    return state.defaultPageSettingForm.layout;
  },
  advanceDefaultForm(state: State) {
    return state.defaultPageSettingForm.advance;
  },
  generalForm(state: State) {
    return state.pageSettingForm.general;
  },
  layoutForm(state: State) {
    return state.pageSettingForm.layout;
  },
  advanceForm(state: State) {
    return state.pageSettingForm.advance;
  },
  settingChangedList(state: State) {
    return state.updatedSettingPageList;
  },
  blogHandle: (state: State) => state.blogHandle,
  defaultPageTitle: (state: State) => state.defaultPageSettingForm.general.title,
  currentPageHandle: (state: State) => state.pageSettingForm.general.handle,
  getIsAssignProductModal: (state: State) => state.assignedProduct.isAssignProductModal,
  blankPageSettingText(state: State) {
    const general = state.pageSettingForm.general;

    /**
     * chỉ kiểm tra 2 field chính là Title, Handle
     */

    // Home, Product, Collection không trả về handle
    return (
      (typeof general.title != 'undefined' && !general.title.trim().length) ||
      (typeof general.handle != 'undefined' && !general.handle.trim().length)
    );
  },
  [GETTERS.GET_ASSIGNED_PRODUCT_LIST](state: State) {
    return state.assignedProduct.list;
  },
  [GETTERS.GET_ID_PRODUCT_DYNAMIC](state: State) {
    return state.assignedProduct.idProductDynamic;
  },
  [GETTERS.GET_POPUP_ASSIGNED_PRODUCT_ACTIVE](state: State) {
    return state.assignedProduct.popupAssignedProductActive;
  },
  [GETTERS.GET_IS_SHOW_MESSAGE_PUBLISH_POPUP](state: State) {
    return state.assignedProduct.isShowMessagePublishPopup;
  },
  [GETTERS.GET_PRODUCT_DYNAMIC](state: State) {
    const idProductDynamic = state.assignedProduct.idProductDynamic;
    let productDynamic = state.assignedProduct.list.find((item: any) => item.id == idProductDynamic);
    if (!productDynamic) {
      productDynamic = {};
    }
    const fields = 'id, title, handle';
    return getFieldsFromObject(fields, productDynamic);
  },
  [GETTERS.GET_IS_INIT_PRELOAD_PRODUCT_SNIPPET](state: State) {
    return state.assignedProduct.isInitPreloadProductSnippet;
  },
  [GETTERS.GET_IS_USED_PRELOAD_PRODUCT_SNIPPET](state: State) {
    return state.assignedProduct.isUsedPreloadProductSnippet;
  },
  [GETTERS.GET_COUNT_PRODUCT_DYNAMIC](state: State) {
    return state.assignedProduct.countProductDynamic;
  },
  [GETTERS.GET_IS_PRODUCT_NOT_FOUND]: (state: State) => {
    return state.isProductNotFound;
  },
};

export default getters;
